import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";

const menusStateSelector = (state: RootState) => state.menus;

export const selectorOpenMenuId = createSelector(
	menusStateSelector,
	(state) => state.openMenuId,
);
